import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from '@mui/material';
import { Close as CloseIcon, Settings as SettingsIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const SettingsRedirectModal = ({ 
  open, 
  onClose,
  userRole = 'customer'
}) => {
  const navigate = useNavigate();

  const handleGoToSettings = () => {
    // Navigate to settings page with two_factor tab based on role
    const settingsPath = userRole === 'customer' 
      ? '/customer/settings?tab=two_factor' 
      : '/vendor/settings?tab=two_factor';
    navigate(settingsPath);
    onClose();
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        }
      }}
    >
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box display="flex" alignItems="center" gap={1}>
            <SettingsIcon color="primary" />
            <Typography variant="h6" component="div">
              Enable Two-Factor Authentication
            </Typography>
          </Box>
          <IconButton onClick={handleClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Typography variant="body1" color="text.secondary" gutterBottom>
            Two-Factor Authentication is required to access files. 
            Please enable 2FA in your settings to access these files securely.
          </Typography>
        </Box>

        <Typography variant="body2" color="text.secondary">
          You will be redirected to the Two-Factor Authentication settings page.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button 
          onClick={handleClose} 
          color="inherit"
        >
          Cancel
        </Button>
        <Button
          onClick={handleGoToSettings}
          variant="contained"
          startIcon={<SettingsIcon />}
        >
          Go to Settings
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SettingsRedirectModal;
